import React from "react";
import PanelNormal from "../../atoms/box/panel-normal";
import BlockTitle from "../../atoms/typography/block-title";
import * as styles from "../navigation/navigation.module.scss";

/**
 * @type {Object} 「UI:molecules - 目次 コンポーネント」DOMです。
 * @return {Object} DOMを返します。
 * @param {Array} children 子コンポーネントを受け取るための引数です。任意の要素を渡します。
 *
 */

const TableOfIndex = ({ children }) => {
  return (
    <div className={`${styles.tableOfIndex}`}>
      <PanelNormal>
        <header>
          <BlockTitle text="目次" />
        </header>
        <div>{children}</div>
      </PanelNormal>
    </div>
  );
};

export default TableOfIndex;
